module.exports = "/images/laura.png?18146d8e08156da3a416651f5ac61d01";